import { partial, string } from 'io-ts/Decoder';

export const Request = partial({
	drawingId: string,
});
